import styled, { css } from "styled-components";
import { theme } from "../../../config";
import { Menu as AntMenu } from "antd";

export const Wrapper = styled.div.attrs(
  (props: { isInterviewer: boolean }) => ({
    ...props,
  })
)`
  background: ${theme.colors.custom.darkblue3};
  height: 100%;
  overflow-y: auto;
  ${(props) =>
    props.isInterviewer &&
    `
  .ant-menu.ant-menu-dark{
    height: 100%;
    display: flex;
    flex-direction: column;

    .ant-menu-item-group {
      height: 100%;
    }

    li:nth-child(3) {
      justify-content: flex-end;
      display: flex;
      flex-direction: column;
    }
  }`}

  .ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal)
    .ant-menu-item-selected {
    background: ${theme.colors.custom.darkblue3};
    color: ${theme.colors.primary};

    .anticon svg {
      color: ${theme.colors.primary};
    }
  }

  .ant-menu-dark.ant-menu-inline .ant-menu-item,
  .ant-menu-dark.ant-menu-inline .ant-menu-submenu-title {
    .anticon svg {
      font-size: 25px;

      @media ${theme.breakpoints.mobileAndTablet} {
        font-size: 20px;
      }
    }
    background: ${theme.colors.custom.darkblue3};
    color: ${theme.colors.white};
    user-select: none;
    font-size: 16px;
    @media ${theme.breakpoints.mobileAndTablet} {
      font-size: 14px;
      line-height: 18px;
    }
  }

  .ant-menu.ant-menu-dark,
  .ant-menu-dark .ant-menu-sub,
  .ant-menu.ant-menu-dark .ant-menu-sub {
    background: ${theme.colors.custom.darkblue3};
    padding-left: 15px;
  }

  &.show {
    @media ${theme.breakpoints.mobileAndTablet} {
      margin-left: 0;
      transition: 0.5s;
    }
  }

  &.hidden {
    @media ${theme.breakpoints.mobileAndTablet} {
      margin-left: -264px;
      transition: 0.1s;
    }
  }
  @media ${theme.breakpoints.mobileAndTablet} {
    position: fixed;
    z-index: 3;
  }
`;

export const Menu = styled(AntMenu)`
  width: 339px;

  &.ant-menu-dark.ant-menu-inline .ant-menu-item,
  &.ant-menu-dark.ant-menu-inline .ant-menu-submenu-title {
    font-size: 14px !important;
  }

  @media ${theme.breakpoints.mobileAndTablet} {
    position: fixed;
    overflow-x: hidden;
    overflow-y: auto;
    height: 100vh;
    width: 264px;
    ${theme.hideScrollbar}
  }
`;

export const MobileViewHeader = styled.div`
  display: none;
  @media ${theme.breakpoints.mobileAndTablet} {
    z-index: 2;
    height: 56px;
    width: 100%;
    background: ${theme.colors.custom.darkblue3};
    display: flex;
    position: fixed;
  }
`;

export const BurgerWrapper = styled.div`
  padding: 20px;
  .anticon {
    color: white;
    font-size: 18px;
    align-items: center;
    top: 50%;
    cursor: pointer;
  }
`;

const LogoStyle = css`
  height: 44.29px;
  @media ${theme.breakpoints.mobileAndTablet} {
    height: 24px;
    margin-top: 19px;
  }
`;

export const Logo = styled.img`
  margin: 58px 0 20px 0;
  ${LogoStyle}
`;

export const Logo2 = styled.img`
  margin: 58px 0 15px 22px;
  ${LogoStyle}
`;

export const PcViewHeader = styled.div`
  @media ${theme.breakpoints.mobileAndTablet} {
    width: 264px;
  }
`;

export const CommonMenuWrapper = styled(AntMenu.ItemGroup).attrs(
  (props: { $isInterviewer: boolean }) => ({
    ...props,
  })
)`
  .ant-menu-item-group-title {
    padding: 0px;
  }
  ${(props) => props.$isInterviewer && `padding-bottom: 30px;`}
`;

export const MenuCloseBtn = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  position: absolute;
  right: 10px;
  top: 16px;
`;
